{
  "checkAgainAria": "{{status}}. Check again",
  "explanation": {
    "checking": "The app is asking the DMW server whether it is ready.",
    "connected": "The DMW server and its database are ready.",
    "databaseUnavailable": "The DMW server is running but cannot reach its database. Data cannot be loaded or saved until it can.",
    "faulty": "The answer does not match what this version of the app expects. The app and the server may be out of step.",
    "unreachable": "The DMW server does not answer. Check that it is running and that this computer is online."
  },
  "reloadToUpdate": "Reload to update",
  "status": {
    "checking": "Checking server",
    "connected": "Server connected",
    "databaseUnavailable": "Database unreachable",
    "faulty": "Server answers unexpectedly",
    "unreachable": "Server unreachable"
  }
}
